<div [formGroup]="fg()">
  <div class="action-setting">
    <div class="action-setting-title">
      {{ 'commonActions.playbookConfirmationMode.description' | labelsProvider }}
    </div>

    <mat-radio-group [value]="confirmationMode()" (change)="onRadioButtonChange($event.value)">
      <div class="radio-option">
        <mat-radio-button [value]="confirmationModeEnum.strict">
          {{ 'commonActions.playbookConfirmationMode.strictModeTitle' | labelsProvider }}
        </mat-radio-button>
        <div class="radio-description">
          {{ 'commonActions.playbookConfirmationMode.strictModeDescription' | labelsProvider }}
        </div>
      </div>

      <div class="radio-option">
        <mat-radio-button [value]="confirmationModeEnum.disabled">
          {{ 'commonActions.playbookConfirmationMode.disabledModeTitle' | labelsProvider }}
        </mat-radio-button>
        <div class="radio-description">
          {{ 'commonActions.playbookConfirmationMode.disabledModeDescription' | labelsProvider }}
        </div>
      </div>
    </mat-radio-group>
  </div>
</div>
